import { render } from "./OrderModal.vue?vue&type=template&id=52c2fd12&scoped=true"
import script from "./OrderModal.vue?vue&type=script&lang=js"
export * from "./OrderModal.vue?vue&type=script&lang=js"

import "./OrderModal.vue?vue&type=style&index=0&id=52c2fd12&lang=scss&scoped=true"
import "./OrderModal.vue?vue&type=style&index=1&id=52c2fd12&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c2fd12"]])

export default __exports__